import { phoneFormat } from '../shared/util';
import React from 'react';

const getTextWithLineBreak = (sentences) => (
    <>
        {sentences.map((s) => {
            return (
                <>
                    {s}
                    <br className='show-lg-up' />
                </>
            );
        })}
    </>
);

const voiceValues = {
    conversational: {
        scheduling: {
            type4: getTextWithLineBreak([
                "Well, we're still looking for a servicer in your area.",
                "Let's take this offline and we'll call you within 24 hours to schedule service."
            ]),
            recommendServicer: 'Do you have the inside scoop? Is there a servicer you recommend?'
        },
        confirmations: {
            type1: 'It’s a date, we’ll see you then.',
            type2_3: 'Get your calendar out, we’ll call you soon.',
            type4: 'Stand by, our team is looking for a servicer.'
        },
        verifyInfo: {
            service: 'Are we coming to the right place and using the best contact info?',
            replacement: 'Are we shipping to the right place and using the best contact info?'
        }
    },
    standard: {
        scheduling: {
            type4: getTextWithLineBreak([
                "We're still looking for a servicer in your area.",
                'We’ll call you within 24 hours to schedule service.'
            ]),
            recommendServicer: 'Is there a servicer you recommend?'
        },
        confirmations: {
            type1: 'Your appointment is confirmed.',
            type2_3: "We'll call you soon to make your appointment.",
            type4: 'We’re locating a servicer and will be in touch soon.',
            savedClaim: 'Your claim has been saved.'
        },
        verifyInfo: {
            service: 'Please confirm your address and preferred contact information.',
            replacement: 'Please confirm your address and preferred contact information.'
        }
    }
};

const textValues = {
    AIG: {
        customerService: {
            email: 'AIGServiceCenter@aig.com',
            phone: phoneFormat('XXXXXXXXXX')
        },
        claim: {
            phone: phoneFormat('XXXXXXXXXX')
        },
        claimOverviewHero: {
            planNumber: 'Plan Number',
            planStatus: 'Plan Status'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        planName: 'protection plan',
        salesConfig: {
            showSaveSale: false,
            showCancelSale: true,
            showCallBanner: false,
            solicitationCheckbox: false,
            showServiceAddress: false,
            useServiceAddress: false,
            showPromoCodeContent: false,
            showAnnualBilling: false,
            showFindMyCheckbox: true
        }
    },
    NJR: {
        customerService: {
            email: 'NewJerseyRetail@aig.com',
            phone: '888-405-0602'
        },
        claim: {
            phone: '877-531-4782'
        },
        claimOverviewHero: {
            planNumber: 'Plan Number',
            planStatus: 'Plan Status'
        },
        planDetails: {
            paymentType: 'Service Fee'
        },
        salesConfig: {
            showSaveSale: true,
            showCancelSale: false,
            showCallBanner: true,
            solicitationCheckbox: true,
            showServiceAddress: true,
            useServiceAddress: true,
            showPromoCodeContent: true,
            showAnnualBilling: true,
            showFindMyCheckbox: false
        }
    },
    APPLE: {
        customerService: {
            email: 'warranty-aigservicecenter@aig.com',
            phone: phoneFormat('8662436434')
        },
        claim: {
            phone: phoneFormat('8662436434')
        },
        claimOverviewHero: {
            planNumber: 'Plan Number',
            planStatus: 'Plan Status'
        },
        planDetails: {
            paymentType: 'Deductible'
        },
        planName: 'AIG Standalone Protection plan',
        salesConfig: {
            showSaveSale: false,
            showCancelSale: true,
            showCallBanner: false,
            solicitationCheckbox: false,
            showServiceAddress: false,
            useServiceAddress: false,
            showPromoCodeContent: false,
            showAnnualBilling: false,
            showFindMyCheckbox: true
        }
    }
};

const getClientContent = (brandId) => {
    // NPB 03312021 - as of today, HWA is the only brand using alternative voicing/tone. anything other than HWA will return "conversational" text.
    const usingStandardTone = ['hwa'];
    const variableVoice = voiceValues[usingStandardTone.includes(brandId) ? 'standard' : 'conversational'];
    const variableText = textValues[brandId];
    return { variableText, variableVoice };
};

export default getClientContent;
